import { Component, OnInit, Input } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { HttpClient } from '@angular/common/http';
import { ProcedureTypeRef } from 'src/app/models/ProcedureTypeRef';
import { ImportFileType } from 'src/app/models/ImportFileType';
import { PointsService } from 'src/app/services/points.service';
import { ProcedureModel } from 'src/app/models/procedure';
import { UiBlockService } from 'src/app/services/ui-block.service';

@Component({
  selector: 'app-procedure-type-selection',
  templateUrl: './procedure-type-selection.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class ProcedureTypeSelectionComponent implements OnInit {

  @Input()
  procedureTypeMap: Map<string, ProcedureTypeRef[]>;

  @Input()
  procedureTypeRowExpanded: boolean[];

  @Input()
  formData: FormData

  @Input()
  isEad51: boolean;

  constructor(public bsModalRef: BsModalService,
    public http: HttpClient,
    public endpointService: EndpointsService,
    public confirmationModal : ModalConfirmationService,
    private modalService: ModalControlService,
    private pointsService: PointsService,
    private uiBlock: UiBlockService,) { }

  ngOnInit(): void {
  }


  cancel():void{
    this.bsModalRef.hide();
  }


  static createProcedureTypeMap( procedureTypeList:ProcedureTypeRef[], isEad51: boolean): Map<string, ProcedureTypeRef[]>{
    const procedureTypeMap = new Map<string, ProcedureTypeRef[]>();
    let type: string;  
    for (const procedureType of procedureTypeList){
      isEad51? type = procedureType.type: type = procedureType.procType;
      procedureType.selected = false;
      if (procedureTypeMap.has(type)){
        procedureTypeMap.get(type).push(procedureType);
      } else {
        procedureTypeMap.set(type, [procedureType]);
      }
    }
    return procedureTypeMap;
  }

  static createRowActiveProperty(map: Map<string, ProcedureTypeRef[]>): boolean[]{
    const toReturn: boolean[] = [];
    map.forEach(() => toReturn.push(false));
    return toReturn;
  }

  colapsableLabelProcedureType(index : number): void {
    this.procedureTypeRowExpanded[index] = !this.procedureTypeRowExpanded[index];
  }

  changeSelectedChild(mapKey: string, index: number){
    this.procedureTypeMap.get(mapKey)[index].selected = !this.procedureTypeMap.get(mapKey)[index].selected;
  }

  changeSelectedParent(mapKey: string, event){
    if (event.target.checked){
      this.selectAllParent(mapKey);
    } else {
      this.deselectAllParent(mapKey);
    }
  }

  checkIfAllSelected(mapKey: string): boolean{
    for (const row of this.procedureTypeMap.get(mapKey)){
      if (!row.selected){
        return false;
      }
    }
    return true;

  }

  selectAllParent(mapKey: string){
    for (const row of this.procedureTypeMap.get(mapKey)){
      row.selected = true;
    }
  }

  deselectAllParent(mapKey: string){
    for (const row of this.procedureTypeMap.get(mapKey)){
      row.selected = false;
    }
  }

  getprocedureTypeSelected(): ProcedureTypeRef[] {
    const toReturn: ProcedureTypeRef[] = [];
    for (const procedureTypes of this.procedureTypeMap.values()){
      for (const row of procedureTypes){
        row.selected? toReturn.push(row): false;
      }
    }
    return toReturn;
  }

  selectAll(){
    for (const key of this.procedureTypeMap.keys()){
      this.selectAllParent(key);
    }
  }

  deselectAll(){
    for (const key of this.procedureTypeMap.keys()){
      this.deselectAllParent(key);
    }
  }

  proceedWithImport(){
    var proceduresSelected = this.getprocedureTypeSelected();  
    if (proceduresSelected.length == 0){
      this.modalService.showMesssageModal("Error", "Please select items to import.");
      return;
    }
    this.cancel();
    let importType :ImportFileType;
    this.isEad51? importType = ImportFileType.PROCEDURES_EAD_51_PHASE2: importType = ImportFileType.PROCEDURES_EAD_45_PHASE2;
    this.formData.append("procedureTypeRefs", JSON.stringify(proceduresSelected));
    this.uiBlock.startBlock('Parsing XML file...');
    this.http
      .post(
        this.endpointService.endpointParseImportFileProcedures + '/' + importType,
        this.formData,
        this.endpointService.httpOptions
      )
      .subscribe((procedures: ProcedureModel[]) => {
        this.uiBlock.stopBlock();
        if (procedures.length == 0){
          this.modalService.showMesssageModal('Procedures','No procedures available to import.');
        } else {
          this.pointsService.importProceduresFromUpload(procedures);
        }
      }, (error) => {
        this.uiBlock.stopBlock();
        this.pointsService.handleImportError(error, "XML");
      })
  }

}
